var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBscNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34084 10.0848L12.0022 5.42534L16.6655 10.0886L19.3763 7.37595L12.0022 0L4.62817 7.37406L7.34084 10.0848Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.001L2.71168 9.2893L5.42335 12.001L2.71168 14.7127L0 12.001Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34097 13.916L12.0024 18.5773L16.6656 13.9141L19.3783 16.6229L19.3764 16.6248L12.0024 24.0008L4.6283 16.6286L4.62451 16.6248L7.34097 13.916Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5767 12.0015L21.2883 9.28979L24 12.0015L21.2883 14.7131L18.5767 12.0015Z",
    fill: "#F3BA2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.753 11.9995L12.0024 9.24707L9.96839 11.2811L9.73333 11.5143L9.25184 11.9958L9.24805 11.9995L9.25184 12.0052L12.0024 14.7539L14.753 12.0014L14.7549 11.9995H14.753Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscNetworkIcon);
export default __webpack_public_path__ + "static/media/bsc-network-icon.de59e09bb3d267b9765cbdbb45c52d63.svg";
export { ForwardRef as ReactComponent };